// generated by srcset-codegen
import src from "./logo-icon.svg";

const width = 19;
const height = 19;
export default { src, width, height };
